$('._preventdefault').on('click', function (e){
    e.preventDefault();
})

$('.hoofdmenubutton').on('click', function(e){
    goToMainMenu();
})

$('.sidebar-menu-item:not(._previousButton)').on('click', function(e) {
    let toggleThis = $(this).data('toggle');
    let $this = $(this);
    goToSubmenu($this, toggleThis);
});

$('.sidebar-menu-subitem').on('click', function(e) {
    let toggleThis = $(this).data('toggle');
    let $this = $(this);
    goToSubSubmenu($this, toggleThis);
});

$('.sidebar-menu-subsubitem').on('click', function(e) {
    let toggleThis = $(this).data('toggle');
    let $this = $(this);
    goToSubSubSubmenu($this, toggleThis);
});

$(document).on('click', "._previousButton", function() {
    let toggleThis = $(this).data('toggle');
    let $this = $(this);
    goToMainSubmenu($this, toggleThis)
});

$('._previousButton').on('click', function(e) {
    let toggleThis = $(this).data('toggle');
    goToMainSubmenu($(this), toggleThis);
});
